import { createStore } from 'easy-peasy';
import authenticationStore, { IAuthenticationStore } from '../authentication/authentication.store';
import placementsStore, { IPlacementsStore } from '../placements/placements.store';
import adminStore, { IAdminStore } from '../admin/admin.store';

export interface IStore {
	admin: IAdminStore;
	authentication: IAuthenticationStore;
	placements: IPlacementsStore;
}

const initialStore: IStore = {
	admin: adminStore,
	authentication: authenticationStore,
	placements: placementsStore,
};

const store = createStore(initialStore, {
	devTools: process.env.NODE_ENV === 'development',
	disableImmer: true,
});

if (process.env.NODE_ENV === 'development') {
	console.log('store:', store, store.getState());
}

export default store;
